import { Link } from '@tanstack/react-router'
import { Button, Flex } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

type CampaignSettingsActionsProps = {
    campaignId: string
    isSubmitting: boolean
}

export function CampaignSettingsActions({ campaignId, isSubmitting }: CampaignSettingsActionsProps) {
    const { t } = useTranslation()

    return (
        <Flex
            gap="small"
            justify="end"
        >
            <Link
                to="/campaigns/$campaignId/board"
                params={{
                    campaignId,
                }}
            >
                <Button>{t('Cancel')}</Button>
            </Link>
            <Button
                loading={isSubmitting}
                type="primary"
                htmlType="submit"
            >
                {t('Save')}
            </Button>
        </Flex>
    )
}
